import { useMemo } from 'react'
import type { RunStatus } from './useRouteOptimization'
import { useWebSocketStore } from './websocket/useWebsocket'

function generateLockedSchedules(runStatus: RunStatus[], lockedSchedules: Gravitate.Schedule[]) {
  return lockedSchedules.map((schedule) => {
    const lockedSchedule = runStatus.find((run) => run.run_id === schedule.run_id)
    return { ...schedule, ...lockedSchedule }
  })
}

export const useLockedSchedules = () => {
  const runStatus = useWebSocketStore((state) => state().runStatus)
  const lockedSchedules = useWebSocketStore((state) => state().lockedSchedules)
  const schedules = useMemo(() => generateLockedSchedules(runStatus, lockedSchedules), [runStatus, lockedSchedules])

  return {
    lockedSchedules: schedules,
    lockedScheduleStream: lockedSchedules,
  }
}
